import React, { Component } from "react";
import { connect } from 'react-redux'
import moment from "moment";

// Users Columns
import SoLieu from './SoLieu'
import SoLieuBieuDo from './SoLieuBieuDo'
import message from "../../../components/Messages";
import Api_tnn from '../../../api/api.tnn';
import Api_quantrac from '../../../api/api.quantrac'
import { Card, Col, Row, Layout } from "antd";
import Constant from '../../../constants/constant';
import Clock from 'react-live-clock';
import Helper from '../../../helper/helper';
import { MESSAGE } from '../../../constants/dictionaries'
import { functionsCode, groupFunctionsCode } from '../../../constants/constant';
import Message from "../../Messages"
import { LineChart, Line, AreaChart, Area, Brush, XAxis, YAxis, CartesianGrid, Tooltip, BarChart, Legend, Bar, ResponsiveContainer } from 'recharts'
import { value } from "numeral";



class ThongKe extends Component {
  constructor(props) {
    super(props);
    const { functions } = props;
    this.state = {
      data_bieudo: [],
      data_bieudobcdk: [],
      data_tpmt: [],
      loading: true
    };

  }


  componentDidMount() {
    this.GetTongGP();

  }
  componentDidUpdate(prevProps, prevState, snapshot) {

  }

  GetTongGP = async () => {
    try {

      const data = await new Api_tnn().GetTongSo_GP({ token: this.props.user.access_token })
      const dataquantrac = await new Api_quantrac().tongso_gp({ token: this.props.user.access_token })
      const datatpmt = await new Api_quantrac().thanhphanmoitruong({ token: this.props.user.access_token })
      const datatpmttnn = await new Api_tnn().thanhphanmoitruongtnn({ token: this.props.user.access_token })

      if (datatpmt && datatpmttnn) {
        datatpmt.map((value, index) => {
          let data_tram = datatpmttnn.filter(x => x.tpmt === value.tpmt)
          if (data_tram && data_tram.length > 0) {
            value.tramqt_doanhnghiep = value.count_tramqt_doanhnghiep + data_tram[0].count_tramqt_doanhnghiep
          } else {
            value.tramqt_doanhnghiep = value.count_tramqt_doanhnghiep
          }
        })
      }

      if (data && dataquantrac) {
        // Giay phep xa thai
        let data_xathai_GP = [
          { name: 'Còn hiệu lực', value: data.count_xnt_hl - data.count_xnt_shhl, backGroundColor: "#52c41a", value_tong: data.count_xnt, tittle_tong: "Tổng số", tittle_cgbc: "Chưa gửi báo cáo" },
          { name: 'Sắp hết hiệu lực', value: data.count_xnt_shhl, backGroundColor: "#faad14" },
          { name: 'Hết hiệu lực', value: data.count_xnt_hhl, backGroundColor: "#f5222d" },
        ]
        let data_xathai_BCDK = [
          { indicatorbcdk: 'Bình thường', value_bcdk: data.count_xnt_baocao_binhthuong, backGroundColor: "#52c41a", value_tong_bcdk: data.count_xnt_baocao, tittle_tong_bcdk: "Tổng số " },
          { indicatorbcdk: ' Chờ phê duyệt', value_bcdk: data.count_xnt_baocao_chopheduyet, backGroundColor: "#ecd200" },
          { indicatorbcdk: 'Vượt ngưỡng', value_bcdk: data.count_xnt_baocao_vuotchiso, backGroundColor: "#f5222d" },
          { indicatorbcdk: 'Chưa đánh giá', value_bcdk: data.count_xnt_baocao_chuadanhgia, backGroundColor: "#faad14" },
        ]

        let data_gp_xt = {
          giayphep: data_xathai_GP,
          baocaodinhky: data_xathai_BCDK,
          tittle: "NƯỚC XẢ THẢI",
          tieude: "Giấy Phép",
          chuaguibc: data.count_xnt_chuaguibaocao
        }
        //giay phep nuoc mat
        let data_nuocmat_GP = [
          { name: 'Còn hiệu lực ', value: data.count_nm_hl - data.count_nm_shhl, backGroundColor: "#52c41a", value_tong: data.count_nm, tittle_tong: " Tổng số", tittle_cgbc: " Chưa gửi báo cáo", },
          { name: 'Sắp hết hiệu lực ', value: data.count_nm_shhl, backGroundColor: "#faad14" },
          { name: 'Hết hiệu lực ', value: data.count_nm_hhl, backGroundColor: "#f5222d" },
        ]
        let data_nuocmat_BCDK = [
          { indicatorbcdk: 'Bình thường', value_bcdk: data.count_nm_baocao_binhthuong, backGroundColor: "#52c41a", value_tong_bcdk: data.count_nm_baocao, tittle_tong_bcdk: "Tổng số  " },
          { indicatorbcdk: '  Chờ phê duyệt', value_bcdk: data.count_nm_baocao_chopheduyet, backGroundColor: "#ecd200" },
          { indicatorbcdk: 'Vượt ngưỡng', value_bcdk: data.count_nm_baocao_vuotchiso, backGroundColor: "#f5222d" },
          { indicatorbcdk: 'Chưa đánh giá', value_bcdk: data.count_nm_baocao_chuadanhgia, backGroundColor: "#faad14" },
        ]
        let data_gp_nm = {
          giayphep: data_nuocmat_GP,
          baocaodinhky: data_nuocmat_BCDK,
          tittle: "NƯỚC MẶT",
          tieude: "Giấy Phép",
          chuaguibc: data.count_nm_chuaguibaocao
        }
        // giay phep nuoc dd
        let data_nuocdd_GP = [
          { name: ' Còn hiệu lực', value: data.count_ndd_hl - data.count_ndd_shhl, backGroundColor: "#52c41a", value_tong: data.count_ndd, tittle_tong: "  Tổng số", tittle_cgbc: "  Chưa gửi báo cáo" },
          { name: ' Sắp hết hiệu lực', value: data.count_ndd_shhl, backGroundColor: "#faad14" },
          { name: ' Hết hiệu lực', value: data.count_ndd_hhl, backGroundColor: "#f5222d" },
        ]
        let data_nuocdd_BCDK = [
          { indicatorbcdk: 'Bình thường', value_bcdk: data.count_ndd_baocao_binhthuong, backGroundColor: "#52c41a", value_tong_bcdk: data.count_nm_baocao, tittle_tong_bcdk: "Tổng số   " },
          { indicatorbcdk: '   Chờ phê duyệt', value_bcdk: data.count_ndd_baocao_chopheduyet, backGroundColor: "#ecd200" },
          { indicatorbcdk: 'Vượt ngưỡng', value_bcdk: data.count_ndd_baocao_vuotchiso, backGroundColor: "#f5222d" },
          { indicatorbcdk: 'Chưa đánh giá', value_bcdk: data.count_ndd_baocao_chuadanhgia, backGroundColor: "#faad14" },
        ]
        let data_gp_ndd = {
          giayphep: data_nuocdd_GP,
          baocaodinhky: data_nuocdd_BCDK,
          tittle: "NƯỚC DƯỚI ĐẤT",
          tieude: "Giấy Phép",
          chuaguibc: data.count_ndd_chuaguibaocao
        }
        // DTM
        let data_dtm_qdpd = [
          { name: "", name_1: 'Quyết định phê duyệt', value_qd: dataquantrac.count_dtm },
        ]
        let data_dtm_bcdk = [
          { name: "", indicatorbcdk: 'Bình thường', value_bcdk: dataquantrac.count_dtm_bcdk_binhthuong, backGroundColor: "#52c41a", value_tong_bcdk: dataquantrac.count_dtm_bcdk, tittle_tong_bcdk: " Tổng số ", tittle_cgbc: "Chưa gửi báo cáo " },
          { name: "", indicatorbcdk: 'Chờ phê duyệt ', value_bcdk: dataquantrac.count_dtm_bcdk_chopheduyet, backGroundColor: "#ecd200" },
          { name: "", indicatorbcdk: 'Vượt ngưỡng', value_bcdk: dataquantrac.count_dtm_bcdk_vuotchiso, backGroundColor: "#f5222d" },
          { name: "", indicatorbcdk: 'Chưa đánh giá', value_bcdk: dataquantrac.count_dtm_bcdk_chuadanhgia, backGroundColor: "#faad14", },
        ]

        let data_dtm = {
          giayphep: data_dtm_qdpd,
          baocaodinhky: data_dtm_bcdk,
          tittle: "ĐTM",
          tieude: undefined,
          chuaguibc1: dataquantrac.count_dtm_chuaguibaocao
        }
        //BVMT
        let data_bvmt_qdpd = [
          { name: "", name_1: ' Quyết định phê duyệt', value_qd: dataquantrac.count_bvmt },
        ]
        let data_bvmt_bcdk = [
          { name: "", indicatorbcdk: 'Bình thường', value_bcdk: dataquantrac.count_bvmt_bcdk_binhthuong, backGroundColor: "#52c41a", value_tong_bcdk: dataquantrac.count_bvmt_bcdk, tittle_tong_bcdk: " Tổng số  ", tittle_cgbc: "Chưa gửi báo cáo  " },
          { name: "", indicatorbcdk: 'Chờ phê duyệt  ', value_bcdk: dataquantrac.count_bvmt_bcdk_chopheduyet, backGroundColor: "#ecd200" },
          { name: "", indicatorbcdk: 'Vượt ngưỡng', value_bcdk: dataquantrac.count_bvmt_bcdk_vuotchiso, backGroundColor: "#f5222d" },
          { name: "", indicatorbcdk: 'Chưa đánh giá', value_bcdk: dataquantrac.count_bvmt_bcdk_chuadanhgia, backGroundColor: "#faad14" },
        ]
        // thủ tục môi trường khác
        let data_bvmt = {
          giayphep: data_bvmt_qdpd,
          baocaodinhky: data_bvmt_bcdk,
          tittle: "THỦ TỤC MÔI TRƯỜNG KHÁC",
          tieude: undefined,
          chuaguibc1: dataquantrac.count_bvmt_chuaguibaocao
        }

        let data_all = [data_gp_xt, data_gp_nm, data_gp_ndd, data_dtm, data_bvmt]
        this.setState({
          data_bieudo: data_all,
          datatong: data,
          loading: false
        })


      }
      if (datatpmt && datatpmttnn) {
        this.setState({ data_tpmt: datatpmt, data_tpmttnn: datatpmttnn })
      }
    } catch (err) {
      message.error(err.message)
    }
  }
  Click = (value) => {

    const { functions } = this.props
    const groupFunctions = Helper.handleGroupFunctions(functions, groupFunctionsCode);
    {
      if (value.tpmt === 1 && value.count_tramqt_htmt !== 0) {
        this.props.history.push('/hien-trang-moi-truong/tram-quan-trac')
      } else if (value.tpmt === 2 && value.count_tramqt_htmt !== 0) {
        this.props.history.push('/hien-trang-moi-truong/tram-quan-trac?Tpmt_Ma=2')
      } else if (value.tpmt === 3 && value.count_tramqt_htmt !== 0) {
        this.props.history.push('/hien-trang-moi-truong/tram-quan-trac?Tpmt_Ma=3')
      } else if (value.tpmt === 5 && value.count_tramqt_htmt !== 0) {
        this.props.history.push('/hien-trang-moi-truong/tram-quan-trac?Tpmt_Ma=5')
      } else if (value.tpmt === 9 && value.count_tramqt_htmt !== 0) {
        this.props.history.push('/hien-trang-moi-truong/tram-quan-trac?Tpmt_Ma=9')
      } else if (value.tpmt === 10 && value.count_tramqt_htmt !== 0) {
        this.props.history.push('/hien-trang-moi-truong/tram-quan-trac?Tpmt_Ma=10')
      } else if (value.tpmt === 11 && value.count_tramqt_htmt !== 0) {
        this.props.history.push('/hien-trang-moi-truong/tram-quan-trac?Tpmt_Ma=11')
      } else if (value.tpmt === 12 && value.count_tramqt_htmt !== 0) {
        this.props.history.push('/hien-trang-moi-truong/tram-quan-trac?Tpmt_Ma=12')
      }
      else {
        message.warning("Không có vị trí điểm quan trắc")
      }
    }


  }
  render() {
    const {
      data_bieudo,
      datatong,
      data_tpmt,
      loading
    } = this.state;
    // const COLORS = ["#52c41a", '#faad14', '#f5222d', '#faad14', '#f4953f'];
    const COLORS = ["#52c41a", '#faad14', '#f5222d', '#faad14', '#f4953f'];
    const { user, functions } = this.props;
    return (

      <div >
        {loading ?
          <div />
          :
          <div>
            <Row style={{ background: "#eaecef" }}>

              <h4 className="font" style={{ color: "#3c4b79", paddingLeft: "10px" }}>Thống kê vị trí quan trắc theo thành phần môi trường </h4>

              {data_tpmt.map((value, idx) => {
                if (value.tpmt !== 14 && value.tpmt !== 13) {
                  return <Col xs={24} sm={12} md={6}>
                    <div style={{ margin: 10, background: "#fff", height: "150px" }}>
                      <div >
                        <div className="tieudetrangchu" style={{ paddingLeft: 20 }}>
                          {Constant.THANH_PHAN_MOI_TRUONG_TEN[value.tpmt]}
                        </div>
                        <div className="colorvalue" style={{ color: "rgb(82, 196, 26)" }}><p>{value.tramqt_doanhnghiep ? value.tramqt_doanhnghiep : 0}</p><a >Doanh nghiệp</a></div>
                        <div className="colorvalue" style={{ color: "#faad14" }}><p>{value.count_tramqt_htmt}</p><a onClick={() => this.Click(value)}>Hiện trạng môi trường</a></div>
                        <div className="colorvalue" style={{ color: "#f5222d" }}><p>{value.count_tramqt_ntts}</p><a >Thủy Sản</a></div>
                        <div className="colorvalue" style={{ color: "#10199d" }}><p>{value.count_tramqt_vhl}</p><a>Vịnh Hạ Long</a></div>
                      </div>
                    </div>
                  </Col>
                }
              }
              )}

            </Row>
            <div style={{ background: "#eaecef" }}>

              <h4 className="font" style={{ color: "#3c4b79", paddingLeft: "10px" }}>Thống kê cấp phép và báo cáo định kỳ của doanh nghiệp </h4>
              <Row>
                {data_bieudo.length > 0 && data_bieudo && data_bieudo.map((item, idx) =>
                  <Col xs={24} lg={12} xl={8} style={{ background: "#eaecef" }}>
                    <div style={{ margin: 10 }} className="solieubieudo">
                      <SoLieuBieuDo data={item} functions={functions} history={this.props.history} datatong={datatong} />
                    </div>
                  </Col>
                )}
                <Col xs={24} lg={12} xl={8} style={{ background: "#eaecef" }}>
                  <div style={{ margin: 10 }} className="solieubieudo">
                    <SoLieu data={data_bieudo} history={this.props.history} />
                  </div>
                </Col>
              </Row>
            </div>
          </div>}
      </div>



    );
  }
}

const mapStateToProps = (state) => ({
  user: state.oidc.user,
  functions: state.functions
});

export default connect(mapStateToProps)(ThongKe);
